var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        class: _vm.isMobile && "mt-3",
        attrs: {
          actions: _vm.pageActionConfig,
          "left-side-class": "col-xl-5",
          page: _vm.pageConfig,
          "right-side-class":
            "col-xl-7 align-items-end d-flex pb-3 justify-content-end"
        }
      }),
      (_vm.admissionInfo && !_vm.editMode) || _vm.editMode
        ? _c("student-admission-detail-board", {
            ref: "requestDate",
            staticClass: "mb-4 mt-1",
            attrs: {
              "edit-info": _vm.editInfo,
              "edit-mode": _vm.editMode,
              "is-admission-coordination": _vm.isAdmissionCoordination,
              "is-coordination": _vm.isCoordination,
              "is-group-type": _vm.isGroupModalityType,
              "is-mobile": _vm.isMobile,
              "is-removing": _vm.isRemoving,
              "is-transfer": _vm.isTransfer,
              "specialist-id": _vm.filterSpecialist.model?.id,
              value: _vm.admissionInfo
            },
            on: {
              "edit-type": _vm.setEditModeInGroup,
              onSelectedDate: _vm.onSelectedDate,
              "remove-type": _vm.setRemoveModeInGroup
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-12", class: _vm.isMobile && "px-0" },
        [
          _c("calendar-filter", {
            attrs: {
              "edit-mode": _vm.editMode,
              "is-add-available-space-open": _vm.isAddAvailableSpaceOpen,
              "is-admission-coordination": _vm.isAdmissionCoordination,
              "is-coordination": _vm.isCoordination,
              "is-mobile": _vm.isMobile,
              "model-add-available-space": _vm.modelAddAvailableSpace,
              options: _vm.filter.options
            },
            on: {
              "apply-action": _vm.removeCoordinationByCriteria,
              "change-location-service": _vm.onLocationServiceChange,
              "change-municipality": _vm.onChangeMunicipality,
              "change-provider": _vm.onProviderChange,
              "clean-up": _vm.onCleanUp,
              input: _vm.onApplyFilter,
              "period-changed": function($event) {
                return _vm.onPeriodChanged($event)
              },
              save: _vm.saveAvailableSpace,
              "toggle-add-available-space-open": e =>
                (_vm.isAddAvailableSpaceOpen = e)
            },
            model: {
              value: _vm.filter.model,
              callback: function($$v) {
                _vm.$set(_vm.filter, "model", $$v)
              },
              expression: "filter.model"
            }
          }),
          _c(
            "div",
            { staticClass: "row mt-4" },
            [
              _vm.hasFilterSelected
                ? _c("specialist-list", {
                    staticClass: "col-12 col-md-3 pl-0 w-100",
                    class: _vm.isMobile ? "px-0" : "w-100",
                    attrs: {
                      admission: _vm.admissionInfo,
                      "edit-mode": _vm.editMode,
                      "is-admission-coordination": _vm.isAdmissionCoordination,
                      "is-coordination": _vm.isCoordination,
                      "is-mobile": _vm.isMobile,
                      "is-transfer": _vm.isTransfer,
                      "is-view-mode": _vm.isViewMode,
                      options: _vm.filterSpecialist.options
                    },
                    on: {
                      input: _vm.onSelectSpecialist,
                      "remove-admission-available-space":
                        _vm.onRemoveAdmissionAvailableSpace
                    },
                    model: {
                      value: _vm.filterSpecialist.model,
                      callback: function($$v) {
                        _vm.$set(_vm.filterSpecialist, "model", $$v)
                      },
                      expression: "filterSpecialist.model"
                    }
                  })
                : _vm._e(),
              _c("calendar", {
                staticClass: "col",
                class: { "pl-0": _vm.hasFilterSelected },
                attrs: {
                  admission: _vm.admissionInfo,
                  data: _vm.availableSpaces,
                  "edit-info": _vm.editInfo,
                  "edit-mode": _vm.editMode,
                  filter: _vm.filter.model,
                  "is-admission-coordination": _vm.isAdmissionCoordination,
                  "is-coordination": _vm.isCoordination,
                  "is-transfer": _vm.isTransfer,
                  "practitioner-id": _vm.$refs.requestDate?.practitioner?.id,
                  specialist: _vm.filterSpecialist.model
                },
                on: {
                  "add-admission-available-space":
                    _vm.onAddAdmissionAvailableSpace,
                  "add-available-space": _vm.onAddAvailableSpace,
                  "edit-admission": _vm.editAdmission,
                  "move-admission": _vm.handlerMoveAdmission,
                  "reaload-data": _vm.handleClearAdmission,
                  "refresh-after-remove": _vm.getSpecialistSpace,
                  "remove-admission": _vm.removeAdmission,
                  "select-day": _vm.setDay,
                  "show-popper-state": _vm.showPopperState
                }
              }),
              _vm.selectedAvailableSpace.data
                ? _c("calendar-add-available-space", {
                    staticClass: "available-space-main",
                    attrs: {
                      id: "calendar-add-available-space",
                      data: _vm.selectedAvailableSpace.data,
                      "is-mobile": _vm.isMobile
                    },
                    on: {
                      cancel: _vm.onCancelAvailableSpace,
                      create: _vm.onCreateAvailableSpace
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "mt-3" }, [_c("specialist-legend")], 1)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }